/**
 * Vista: Detalle/Nuevo Reporte de Garantía
 * Formato: AMX-PVTA-FR-06_R3
 * Estructura: Datos generales fijos arriba + 4 tabs (Problema, Evidencia, Diagnóstico, Firmas)
 */

import posventaService from '../services/posventa.service.js';
import personaService from '../services/persona.service.js';
import recepcionService from '../services/recepcion.service.js';
import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import { compressImage } from '../utils/imageCompressor.js';

import { hoyLocal } from '../utils/fechas.js';
export default {
  data: {
    reporte: null,
    isNew: false,
    distribuidores: [],
    tecnicos: [],
    responsablesLinea: [],
    responsablesPosventa: [],
    fotos: [],
    fotosExistentes: [],
    hasUnsavedChanges: false
  },

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nuevo';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
          <h2 class="card-title">${this.data.isNew ? 'Nuevo Reporte de Garantía' : 'Reporte de Garantía'}</h2>
          <div id="headerButtons" style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/posventa/reportes-garantia')">← Volver</button>
          </div>
        </div>
        <div id="reporteContent"><div style="text-align: center; padding: 2rem;">Cargando...</div></div>
      </div>
    `;
  },

  async afterRender(params) {
    window.reporteGarantiaDetalleView = this;
    this.data.hasUnsavedChanges = false;
    this.injectStyles();

    // Cargar catálogos — distribuidores y responsables desde usuarios con persona (patrón unificado)
    try {
      const usuariosResp = await api.get('/usuarios/responsables').catch(() => ({ data: [] }));
      const todos = Array.isArray(usuariosResp.data) ? usuariosResp.data : (usuariosResp.data?.usuarios || []);
      const usuariosConPersona = todos
        .filter(u => u.persona_id)
        .map(u => ({ id: u.persona_id, nombre_completo: u.persona_nombre_completo || u.nombre_completo }));

      this.data.distribuidores = usuariosConPersona;
      this.data.tecnicos = usuariosConPersona;
      this.data.responsablesLinea = usuariosConPersona;
      this.data.responsablesPosventa = usuariosConPersona;
    } catch (e) { /* catálogos opcionales */ }

    if (this.data.isNew) {
      this.renderFormularioNuevo();
    } else {
      await this.cargarReporte(params.id);
    }
  },

  injectStyles() {
    if (document.getElementById('rg-detalle-styles')) return;
    const style = document.createElement('style');
    style.id = 'rg-detalle-styles';
    style.textContent = `
      .rg-tabs-bar { display: flex; padding: 0; background: transparent; border-bottom: 2px solid #e5e7eb; margin-bottom: 1rem; }
      .rg-tab { flex: 1; padding: 0.6rem 1rem; border: none; border-bottom: 3px solid transparent; margin-bottom: -2px; background: transparent; color: #6b7280; font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; text-align: center; }
      .rg-tab:hover:not(.active) { color: #374151; border-bottom-color: #d1d5db; }
      .rg-tab.active { color: var(--primary); font-weight: 600; border-bottom-color: var(--primary); }
      @media (max-width: 640px) {
        .rg-tabs-bar { display: grid; grid-template-columns: 1fr 1fr; gap: 0.3rem; padding: 0.3rem; }
        .rg-tab { padding: 0.4rem 0.5rem; font-size: 0.75rem; }
        .rg-grid-2col { grid-template-columns: 1fr !important; }
      }
      .rg-detail-row { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem; margin-bottom: 1rem; }
      .rg-detail-item strong { display: block; font-size: 0.85rem; color: var(--text-secondary); margin-bottom: 0.25rem; }
      .rg-uppercase { text-transform: uppercase; }
    `;
    document.head.appendChild(style);
  },

  // ======================== CARGAR REPORTE ========================

  async cargarReporte(id) {
    try {
      const response = await posventaService.obtenerReporteGarantia(id);
      this.data.reporte = response.data || response;
      this.data.fotosExistentes = this.data.reporte.fotos || [];
      this.data.fotos = [];

      if (this.data.reporte.completada) {
        this.renderReporteCompletado();
      } else {
        this.renderFormularioEdicion();
      }
    } catch (error) {
      toast.error('Error al cargar reporte');
      router.navigate('/posventa/reportes-garantia');
    }
  },

  // ======================== FORMULARIO NUEVO ========================

  renderFormularioNuevo() {
    const container = document.getElementById('reporteContent');
    const hoy = hoyLocal();

    // Verificar si viene con num_serie desde la URL
    const urlParams = new URLSearchParams(window.location.search);
    const numSerieFromUrl = urlParams.get('num_serie') || '';

    container.innerHTML = `
      <!-- Buscar Tractor -->
      <div style="background: white; border: 1px solid var(--gray-200); padding: 1.25rem 1.5rem; border-radius: 8px; margin-bottom: 1rem;">
        <h4 style="margin: 0 0 0.25rem; font-size: 1rem; font-weight: 600;">Buscar por número de serie</h4>
        <p style="margin: 0 0 1rem; color: var(--text-muted); font-size: 0.85rem;">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
        <div style="display: flex; gap: 0.75rem; align-items: center;">
          <input
            type="text"
            id="numSerieBuscar"
            class="form-input"
            style="flex: 1;"
            placeholder="Ej: TE354-2026-0127"
            value="${numSerieFromUrl}"
          />
          <button type="button" class="btn btn-primary" onclick="window.reporteGarantiaDetalleView.buscarTractor()">
            Buscar
          </button>
        </div>
        <div id="tractorResult" style="margin-top: 1rem;"></div>
      </div>

      <div id="formularioPrincipal" style="display: none;">
        <!-- Datos generales fijos -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Datos Generales</h3>
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
            <div class="form-group">
              <label class="form-label">Marca</label>
              <input type="text" id="rgMarca" class="form-input" readonly />
            </div>
            <div class="form-group">
              <label class="form-label">Modelo</label>
              <input type="text" id="rgModelo" class="form-input" readonly />
            </div>
            <input type="hidden" id="rgNumSerie" />
            <div class="form-group">
              <label class="form-label">Usuario</label>
              <input type="text" id="rgUsuario" class="form-input" readonly placeholder="Se llena automáticamente" />
            </div>
            <div class="form-group">
              <label class="form-label">Fecha de Entrega *</label>
              <input type="date" id="rgFechaEntrega" class="form-input" />
            </div>
            <div class="form-group">
              <label class="form-label">Fecha del Reporte *</label>
              <input type="date" id="rgFechaReporte" class="form-input" value="${hoy}" />
            </div>
            <div class="form-group">
              <label class="form-label">Hr de Operación *</label>
              <input type="number" id="rgHrOperacion" class="form-input" min="0" placeholder="Opcional" />
            </div>
            <div class="form-group">
              <label class="form-label">Distribuidor *</label>
              <select id="rgDistribuidor" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.distribuidores.map(d => `<option value="${d.nombre_completo}">${d.nombre_completo}</option>`).join('')}
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Técnico de Servicio *</label>
              <select id="rgTecnico" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.tecnicos.map(t => `<option value="${t.nombre_completo}">${t.nombre_completo}</option>`).join('')}
              </select>
            </div>
          </div>
        </div>

        <p style="font-size: 0.85rem; color: var(--text-secondary); margin-bottom: 1.5rem; font-style: italic;">*En caso de que la reclamación de garantía se refiera a un tractor LOVOL, se debe adjuntar fotografía del horómetro, mostrando las horas de operación.</p>

        <!-- Tabs -->
        <div class="rg-tabs-bar" id="rgTabsBar">
          <button class="rg-tab active" onclick="window.reporteGarantiaDetalleView.showTab('problema')">Problema</button>
          <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('evidencia')">Evidencia</button>
          <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('diagnostico')">Diagnóstico</button>
        </div>

        <!-- Tab Problema -->
        <div class="rg-panel" id="panel-problema" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
          <div class="form-group">
            <label class="form-label">Descripción del problema / falla</label>
            <textarea id="rgDescripcion" class="form-input rg-uppercase" rows="4" placeholder="Describa el problema encontrado..."></textarea>
          </div>
          <div class="form-group">
            <label class="form-label">Labor previa y mantenimiento que se le ha dado a la unidad</label>
            <textarea id="rgLaborPrevia" class="form-input rg-uppercase" rows="4" placeholder="Describa las labores previas..."></textarea>
          </div>
        </div>

        <!-- Tab Evidencia -->
        <div class="rg-panel" id="panel-evidencia" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <p style="margin-bottom: 1rem; color: var(--text-secondary); font-size: 0.875rem;">Fotografías (máx. 4)</p>
          <div class="fotos-grid-new" id="rgFotoGrid">
            ${this._renderFotoPlaceholders(0)}
          </div>
          <input type="file" id="rgFotoInput" accept="image/*" style="display: none;" onchange="window.reporteGarantiaDetalleView.agregarFoto(event)" />
        </div>

        <!-- Tab Diagnóstico -->
        <div class="rg-panel" id="panel-diagnostico" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <p style="color: #dc3545; font-size: 0.875rem; margin-bottom: 1rem;">Los siguientes apartados son llenados por el área de posventa, de AGROMX</p>
          <div class="form-group">
            <label class="form-label">Causas del problema</label>
            <textarea id="rgCausas" class="form-input rg-uppercase" rows="3" placeholder="Causas identificadas..."></textarea>
          </div>
          <div class="form-group">
            <label class="form-label">Observaciones</label>
            <textarea id="rgObservaciones" class="form-input rg-uppercase" rows="3" placeholder="Observaciones del diagnóstico..."></textarea>
          </div>
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
            <div class="form-group">
              <label class="form-label">Dictamen</label>
              <select id="rgDictamen" class="form-input">
                <option value="">Seleccione...</option>
                <option value="valida">Válida</option>
                <option value="nula">Nula</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Fecha de Cierre</label>
              <input type="date" id="rgFechaCierre" class="form-input" />
            </div>
          </div>
          <div style="display: flex; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem;">
            <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgCap" /> CAP</label>
            <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgRef" /> REF</label>
            <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgFac" /> FAC</label>
            <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgAye" /> AYE</label>
          </div>
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
            <div class="form-group">
              <label class="form-label">Responsable línea de producto</label>
              <select id="rgRespLinea" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.responsablesLinea.map(r => `<option value="${r.nombre_completo}">${r.nombre_completo}</option>`).join('')}
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Responsable área de posventa</label>
              <select id="rgRespPosventa" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.responsablesPosventa.map(r => `<option value="${r.nombre_completo}">${r.nombre_completo}</option>`).join('')}
              </select>
            </div>
          </div>
        </div>

        <!-- Botones -->
        <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-top: 1.5rem;">
          <button type="button" class="btn btn-secondary" onclick="window.reporteGarantiaDetalleView.volverConConfirmacion()">Cancelar</button>
          <button type="button" class="btn btn-success" onclick="window.reporteGarantiaDetalleView.guardarNuevo()">Crear Reporte</button>
        </div>
      </div>
    `;

    // Buscar al presionar Enter; ocultar formulario si modifican el NS después de buscar
    const nsBuscar = document.getElementById('numSerieBuscar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.buscarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        if (this.data.tractor) {
          this.data.tractor = null;
          const fp = document.getElementById('formularioPrincipal');
          if (fp) fp.style.display = 'none';
          const result = document.getElementById('tractorResult');
          if (result) result.innerHTML = '';
        }
      });
    }

    // Si viene con num_serie, buscar automáticamente
    if (numSerieFromUrl) {
      this.buscarTractor();
    }

    this._setupUnsavedChangesListener();
  },

  // ======================== FORMULARIO EDICIÓN ========================

  renderFormularioEdicion() {
    const container = document.getElementById('reporteContent');
    const r = this.data.reporte;

    // Botones del header
    const headerButtons = document.getElementById('headerButtons');
    if (headerButtons) {
      headerButtons.innerHTML = `
        <button class="btn btn-secondary" onclick="window.reporteGarantiaDetalleView.volverConConfirmacion()">← Volver</button>
      `;
    }

    container.innerHTML = `
      <!-- Datos generales fijos -->
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
        <h3 style="margin-bottom: 1rem;">Datos Generales</h3>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
          <div class="form-group">
            <label class="form-label">Marca</label>
            <input type="text" id="rgMarca" class="form-input" readonly value="${r.marca || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Modelo</label>
            <input type="text" id="rgModelo" class="form-input" readonly value="${r.modelo || ''}" />
          </div>
          <input type="hidden" id="rgNumSerie" value="${r.num_serie || ''}" />
          <div class="form-group">
            <label class="form-label">Usuario</label>
            <input type="text" id="rgUsuario" class="form-input" readonly value="${r.usuario || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Fecha de Entrega *</label>
            <input type="date" id="rgFechaEntrega" class="form-input" value="${r.fecha_entrega ? r.fecha_entrega.split('T')[0] : ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Fecha del Reporte *</label>
            <input type="date" id="rgFechaReporte" class="form-input" value="${r.fecha_reporte ? r.fecha_reporte.split('T')[0] : ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Hr de Operación *</label>
            <input type="number" id="rgHrOperacion" class="form-input" min="0" value="${r.hr_operacion || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Distribuidor</label>
            <input type="text" id="rgDistribuidor" class="form-input" readonly value="${r.distribuidor || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Técnico de Servicio</label>
            <input type="text" id="rgTecnico" class="form-input" readonly value="${r.tecnico_servicio || ''}" />
          </div>
        </div>
      </div>

      <p style="font-size: 0.85rem; color: var(--text-secondary); margin-bottom: 1.5rem; font-style: italic;">*En caso de que la reclamación de garantía se refiera a un tractor LOVOL, se debe adjuntar fotografía del horómetro, mostrando las horas de operación.</p>

      <!-- Tabs -->
      <div class="rg-tabs-bar" id="rgTabsBar">
        <button class="rg-tab active" onclick="window.reporteGarantiaDetalleView.showTab('problema')">Problema</button>
        <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('evidencia')">Evidencia</button>
        <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('diagnostico')">Diagnóstico</button>
        <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('firmas')">Firmas</button>
      </div>

      <!-- Tab Problema -->
      <div class="rg-panel" id="panel-problema" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
        <div class="form-group">
          <label class="form-label">Descripción del problema / falla</label>
          <textarea id="rgDescripcion" class="form-input rg-uppercase" rows="4">${r.descripcion_problema || ''}</textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Labor previa y mantenimiento que se le ha dado a la unidad</label>
          <textarea id="rgLaborPrevia" class="form-input rg-uppercase" rows="4">${r.labor_previa_mantenimiento || ''}</textarea>
        </div>
      </div>

      <!-- Tab Evidencia -->
      <div class="rg-panel" id="panel-evidencia" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <p style="margin-bottom: 1rem; color: var(--text-secondary); font-size: 0.875rem;">Fotografías (máx. 4)</p>
        <div class="fotos-grid-new" id="rgFotoGrid">
          ${this._renderFotosEdicion()}
        </div>
        <input type="file" id="rgFotoInput" accept="image/*" style="display: none;" onchange="window.reporteGarantiaDetalleView.agregarFoto(event)" />
      </div>

      <!-- Tab Diagnóstico -->
      <div class="rg-panel" id="panel-diagnostico" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <p style="color: #dc3545; font-size: 0.875rem; margin-bottom: 1rem;">Los siguientes apartados son llenados por el área de posventa, de AGROMX</p>
        <div class="form-group">
          <label class="form-label">Causas del problema</label>
          <textarea id="rgCausas" class="form-input rg-uppercase" rows="3">${r.causas_problema || ''}</textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Observaciones</label>
          <textarea id="rgObservaciones" class="form-input rg-uppercase" rows="3">${r.observaciones_diagnostico || ''}</textarea>
        </div>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
          <div class="form-group">
            <label class="form-label">Dictamen</label>
            <select id="rgDictamen" class="form-input">
              <option value="">Seleccione...</option>
              <option value="valida" ${r.dictamen === 'valida' ? 'selected' : ''}>Válida</option>
              <option value="nula" ${r.dictamen === 'nula' ? 'selected' : ''}>Nula</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Fecha de Cierre</label>
            <input type="date" id="rgFechaCierre" class="form-input" value="${r.fecha_cierre ? r.fecha_cierre.split('T')[0] : ''}" />
          </div>
        </div>
        <div style="display: flex; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem;">
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgCap" ${r.cap ? 'checked' : ''} /> CAP</label>
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgRef" ${r.ref ? 'checked' : ''} /> REF</label>
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgFac" ${r.fac ? 'checked' : ''} /> FAC</label>
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" id="rgAye" ${r.aye ? 'checked' : ''} /> AYE</label>
        </div>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
          <div class="form-group">
            <label class="form-label">Responsable línea de producto</label>
            <select id="rgRespLinea" class="form-input">
              <option value="">Seleccione...</option>
              ${this.data.responsablesLinea.map(p => `<option value="${p.nombre_completo}" ${r.responsable_linea === p.nombre_completo ? 'selected' : ''}>${p.nombre_completo}</option>`).join('')}
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Responsable área de posventa</label>
            <select id="rgRespPosventa" class="form-input">
              <option value="">Seleccione...</option>
              ${this.data.responsablesPosventa.map(p => `<option value="${p.nombre_completo}" ${r.responsable_posventa === p.nombre_completo ? 'selected' : ''}>${p.nombre_completo}</option>`).join('')}
            </select>
          </div>
        </div>
      </div>

      <!-- Tab Firmas -->
      <div class="rg-panel" id="panel-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <div id="firmasContainer" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;" class="rg-grid-2col">
        </div>
      </div>

      <!-- Indicador de cambios sin guardar -->
      <div id="unsavedBanner" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
        Hay cambios sin guardar
      </div>

      <!-- Botones -->
      <div style="display: flex; gap: 1rem; justify-content: flex-end;">
        <button type="button" class="btn btn-secondary" onclick="window.reporteGarantiaDetalleView.volverConConfirmacion()">Cancelar</button>
        <button type="button" class="btn btn-primary" onclick="window.reporteGarantiaDetalleView.guardarCambios()">Guardar Cambios</button>
        ${permisos.can('garantias', 'cerrar') ? `<button type="button" class="btn btn-success" onclick="window.reporteGarantiaDetalleView.completarReporte()">Completar</button>` : ''}
      </div>
    `;

    this._setupUnsavedChangesListener();
  },

  // ======================== VISTA COMPLETADO (solo lectura) ========================

  renderReporteCompletado() {
    const container = document.getElementById('reporteContent');
    const r = this.data.reporte;

    // Botones del header: Volver, Imprimir, Descargar PDF
    const headerButtons = document.getElementById('headerButtons');
    if (headerButtons) {
      headerButtons.innerHTML = `
        <button class="btn btn-secondary" onclick="router.navigate('/posventa/reportes-garantia')">← Volver</button>
        ${permisos.canPrint('garantias') ? `<button class="btn btn-primary" onclick="window.reporteGarantiaDetalleView.imprimir()">🖨️ Imprimir</button>
        <button class="btn btn-success" onclick="window.reporteGarantiaDetalleView.descargarPDF()">📄 Descargar PDF</button>` : ''}
      `;
    }

    container.innerHTML = `
      <!-- Datos generales fijos -->
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
        <h3 style="margin-bottom: 1rem;">Datos Generales</h3>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
          <div class="form-group">
            <label class="form-label">Marca</label>
            <input type="text" class="form-input" readonly value="${r.marca || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Modelo</label>
            <input type="text" class="form-input" readonly value="${r.modelo || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Usuario</label>
            <input type="text" class="form-input" readonly value="${r.usuario || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Fecha de Entrega</label>
            <input type="date" class="form-input" readonly value="${r.fecha_entrega ? r.fecha_entrega.split('T')[0] : ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Fecha del Reporte</label>
            <input type="date" class="form-input" readonly value="${r.fecha_reporte ? r.fecha_reporte.split('T')[0] : ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Hr de Operación</label>
            <input type="number" class="form-input" readonly value="${r.hr_operacion || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Distribuidor</label>
            <input type="text" class="form-input" readonly value="${r.distribuidor || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Técnico de Servicio</label>
            <input type="text" class="form-input" readonly value="${r.tecnico_servicio || ''}" />
          </div>
        </div>
      </div>

      <p style="font-size: 0.85rem; color: var(--text-secondary); margin-bottom: 1.5rem; font-style: italic;">*En caso de que la reclamación de garantía se refiera a un tractor LOVOL, se debe adjuntar fotografía del horómetro, mostrando las horas de operación.</p>

      <!-- Tabs -->
      <div class="rg-tabs-bar" id="rgTabsBar">
        <button class="rg-tab active" onclick="window.reporteGarantiaDetalleView.showTab('problema')">Problema</button>
        <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('evidencia')">Evidencia</button>
        <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('diagnostico')">Diagnóstico</button>
        <button class="rg-tab" onclick="window.reporteGarantiaDetalleView.showTab('firmas')">Firmas</button>
      </div>

      <!-- Tab Problema -->
      <div class="rg-panel" id="panel-problema" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
        <div class="form-group">
          <label class="form-label">Descripción del problema / falla</label>
          <textarea class="form-input rg-uppercase" rows="4" readonly>${r.descripcion_problema || ''}</textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Labor previa y mantenimiento que se le ha dado a la unidad</label>
          <textarea class="form-input rg-uppercase" rows="4" readonly>${r.labor_previa_mantenimiento || ''}</textarea>
        </div>
      </div>

      <!-- Tab Evidencia -->
      <div class="rg-panel" id="panel-evidencia" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <p style="margin-bottom: 1rem; color: var(--text-secondary); font-size: 0.875rem;">Fotografías</p>
        <div class="fotos-grid-new">
          ${(r.fotos || []).map(f => `
            <div class="foto-item">
              <a href="${f.foto_url}" target="_blank"><img src="${f.foto_url}" alt="Evidencia" /></a>
            </div>
          `).join('') || '<p style="color: var(--text-secondary);">Sin fotografías</p>'}
        </div>
      </div>

      <!-- Tab Diagnóstico -->
      <div class="rg-panel" id="panel-diagnostico" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <p style="color: #dc3545; font-size: 0.875rem; margin-bottom: 1rem;">Los siguientes apartados son llenados por el área de posventa, de AGROMX</p>
        <div class="form-group">
          <label class="form-label">Causas del problema</label>
          <textarea class="form-input rg-uppercase" rows="3" readonly>${r.causas_problema || ''}</textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Observaciones</label>
          <textarea class="form-input rg-uppercase" rows="3" readonly>${r.observaciones_diagnostico || ''}</textarea>
        </div>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
          <div class="form-group">
            <label class="form-label">Dictamen</label>
            <input type="text" class="form-input" readonly value="${r.dictamen ? (r.dictamen === 'valida' ? 'Válida' : 'Nula') : ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Fecha de Cierre</label>
            <input type="date" class="form-input" readonly value="${r.fecha_cierre ? r.fecha_cierre.split('T')[0] : ''}" />
          </div>
        </div>
        <div style="display: flex; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem;">
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" disabled ${r.cap ? 'checked' : ''} /> CAP</label>
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" disabled ${r.ref ? 'checked' : ''} /> REF</label>
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" disabled ${r.fac ? 'checked' : ''} /> FAC</label>
          <label style="display: flex; align-items: center; gap: 0.5rem;"><input type="checkbox" disabled ${r.aye ? 'checked' : ''} /> AYE</label>
        </div>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="rg-grid-2col">
          <div class="form-group">
            <label class="form-label">Responsable línea de producto</label>
            <input type="text" class="form-input" readonly value="${r.responsable_linea || ''}" />
          </div>
          <div class="form-group">
            <label class="form-label">Responsable área de posventa</label>
            <input type="text" class="form-input" readonly value="${r.responsable_posventa || ''}" />
          </div>
        </div>
      </div>

      <!-- Tab Firmas -->
      <div class="rg-panel" id="panel-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;" class="rg-grid-2col">
          ${this._renderFirmaDetalle('Técnico de Servicio', r.tecnico_servicio_firma_url, r.tecnico_servicio)}
          ${this._renderFirmaDetalle('Usuario', r.usuario_firma_url, r.usuario)}
          ${this._renderFirmaDetalle('Resp. línea de producto', r.responsable_linea_firma_url, r.responsable_linea)}
          ${this._renderFirmaDetalle('Resp. área de posventa', r.responsable_posventa_firma_url, r.responsable_posventa)}
        </div>
      </div>
    `;
  },

  // ======================== TABS ========================

  showTab(tab) {
    document.querySelectorAll('.rg-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.rg-tab[onclick*="'${tab}'"]`)?.classList.add('active');
    document.querySelectorAll('.rg-panel').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-${tab}`);
    if (panel) panel.style.display = 'block';

    if (tab === 'firmas' && !this.data.reporte?.completada) {
      this._renderFirmasDinamicas();
      this.initFirmas();
    }
  },

  // ======================== BUSCAR TRACTOR ========================

  async buscarTractor() {
    const numSerie = document.getElementById('numSerieBuscar')?.value?.trim();
    if (!numSerie) { toast.error('Ingrese el número de serie'); return; }

    const resultDiv = document.getElementById('tractorResult');
    resultDiv.innerHTML = '<p>Buscando...</p>';

    try {
      const response = await posventaService.obtenerPolizaPorNumSerie(numSerie);
      const tractor = response.data || response;
      this.data.tractor = tractor;

      resultDiv.innerHTML = '';

      document.getElementById('formularioPrincipal').style.display = 'block';
      document.getElementById('rgMarca').value = tractor.marca || '';
      document.getElementById('rgModelo').value = tractor.modelo || '';
      document.getElementById('rgNumSerie').value = numSerie;
      if (tractor.propietario) document.getElementById('rgUsuario').value = tractor.propietario;
      if (tractor.fecha_entrega) document.getElementById('rgFechaEntrega').value = tractor.fecha_entrega.split('T')[0];
    } catch (error) {
      this.data.tractor = null;
      resultDiv.innerHTML = `
        <div style="padding: 0.75rem; background: var(--warning); color: white; border-radius: 8px;">
          <strong>No se encontró tractor con ese número de serie</strong>
        </div>
      `;
      document.getElementById('formularioPrincipal').style.display = 'none';
    }
  },

  // ======================== FOTOS ========================

  _renderFotoPlaceholders(count) {
    let html = '';
    // Placeholders con icono de cámara
    for (let i = count; i < 3; i++) {
      html += `<div class="foto-placeholder"><span class="foto-placeholder-icon">📷</span></div>`;
    }
    // Botón azul "+" para agregar
    if (count < 4) {
      html += `<div class="foto-add-btn" onclick="document.getElementById('rgFotoInput').click()">+</div>`;
    }
    return html;
  },

  _renderFotosEdicion() {
    let html = '';
    // Fotos existentes
    this.data.fotosExistentes.forEach((f, i) => {
      html += `
        <div class="foto-item">
          <img src="${f.foto_url}" onclick="window.open('${f.foto_url}', '_blank')" />
          <button class="foto-remove" onclick="window.reporteGarantiaDetalleView.removerFotoExistente(${i})">×</button>
        </div>
      `;
    });
    // Fotos nuevas
    this.data.fotos.forEach((f, i) => {
      html += `
        <div class="foto-item">
          <img src="${URL.createObjectURL(f)}" />
          <button class="foto-remove" onclick="window.reporteGarantiaDetalleView.removerFotoNueva(${i})">×</button>
        </div>
      `;
    });
    const total = this.data.fotosExistentes.length + this.data.fotos.length;
    // Placeholders vacíos hasta completar 3 visibles
    for (let i = total; i < 3; i++) {
      html += `<div class="foto-placeholder"><span class="foto-placeholder-icon">📷</span></div>`;
    }
    // Botón azul "+" si hay espacio
    if (total < 4) {
      html += `<div class="foto-add-btn" onclick="document.getElementById('rgFotoInput').click()">+</div>`;
    }
    return html;
  },

  async agregarFoto(event) {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = '';

    const total = this.data.fotosExistentes.length + this.data.fotos.length;
    if (total >= 4) { toast.error('Máximo 4 fotografías'); return; }

    const compressed = await compressImage(file);
    this.data.fotos.push(compressed);
    this.data.hasUnsavedChanges = true;
    this._actualizarFotoGrid();
  },

  removerFotoNueva(idx) {
    this.data.fotos.splice(idx, 1);
    this.data.hasUnsavedChanges = true;
    this._actualizarFotoGrid();
  },

  removerFotoExistente(idx) {
    this.data.fotosExistentes.splice(idx, 1);
    this.data.hasUnsavedChanges = true;
    this._actualizarFotoGrid();
  },

  _actualizarFotoGrid() {
    const grid = document.getElementById('rgFotoGrid');
    if (grid) grid.innerHTML = this._renderFotosEdicion();
  },

  // ======================== FIRMAS ========================

  _renderFirmaDisabled(label) {
    return `
      <div class="firma-container-new" style="text-align: center;">
        <label class="form-label firma-label">${label}</label>
        <p style="margin: 0 0 0.5rem; font-weight: 600; color: var(--text-secondary);">Seleccione en tab Diagnóstico</p>
      </div>
    `;
  },

  _renderFirmasDinamicas() {
    const container = document.getElementById('firmasContainer');
    if (!container) return;

    const r = this.data.reporte || {};
    const respLinea = document.getElementById('rgRespLinea')?.value || r.responsable_linea || '';
    const respPosventa = document.getElementById('rgRespPosventa')?.value || r.responsable_posventa || '';

    // Limpiar todos los pads ya que se re-renderiza el HTML completo
    this.signaturePad_tecnico_servicio = null;
    this.signaturePad_usuario = null;
    this.signaturePad_responsable_linea = null;
    this.signaturePad_responsable_posventa = null;

    container.innerHTML = `
      ${this._renderFirmaEdicion('tecnico_servicio', 'Técnico de Servicio', r.tecnico_servicio, r.tecnico_servicio_firma_url)}
      ${this._renderFirmaEdicion('usuario', 'Usuario', r.usuario, r.usuario_firma_url)}
      ${respLinea
        ? this._renderFirmaEdicion('responsable_linea', 'Resp. línea de producto', respLinea, r.responsable_linea_firma_url)
        : this._renderFirmaDisabled('Resp. línea de producto')
      }
      ${respPosventa
        ? this._renderFirmaEdicion('responsable_posventa', 'Resp. área de posventa', respPosventa, r.responsable_posventa_firma_url)
        : this._renderFirmaDisabled('Resp. área de posventa')
      }
    `;
  },

  _renderFirmaCanvas(tipo, label, nombre) {
    return `
      <div class="firma-container-new" style="text-align: center;">
        <label class="form-label firma-label">${label}</label>
        <p style="margin: 0 0 0.5rem; font-weight: 600;">${nombre || ''}</p>
        <div class="firma-box">
          <canvas id="firma-${tipo}" class="firma-canvas-new"></canvas>
          <span class="firma-placeholder" id="firma-placeholder-${tipo}">Toque para firmar</span>
        </div>
        <a href="javascript:void(0)" class="firma-limpiar" onclick="window.reporteGarantiaDetalleView.limpiarFirma('${tipo}')">Limpiar</a>
      </div>
    `;
  },

  _renderFirmaEdicion(tipo, label, nombre, existingUrl) {
    if (existingUrl) {
      return `
        <div class="firma-container-new" style="text-align: center;">
          <label class="form-label firma-label">${label}</label>
          <p style="margin: 0 0 0.5rem; font-weight: 600;">${nombre || ''}</p>
          <img src="${existingUrl}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
          <a href="javascript:void(0)" class="firma-limpiar" onclick="window.reporteGarantiaDetalleView.cambiarFirmaExistente('${tipo}')">Cambiar firma</a>
        </div>
      `;
    }
    return this._renderFirmaCanvas(tipo, label, nombre);
  },

  _renderFirmaDetalle(label, url, nombre) {
    return `
      <div class="firma-container-new" style="text-align: center;">
        ${url
          ? `<img src="${url}" style="width: 100%; max-height: 100px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />`
          : '<div style="min-height: 100px; display: flex; align-items: center; justify-content: center;"><span style="color: var(--text-secondary);">Sin firma</span></div>'
        }
        <hr style="border: none; border-top: 1px solid #000; margin: 0.25rem 0;" />
        <p style="margin: 0.5rem 0 0; font-weight: 700; font-size: 0.95rem;">${nombre || ''}</p>
        <p style="margin: 0; color: var(--text-secondary); font-size: 0.85rem;">${label}</p>
      </div>
    `;
  },

  async initFirmas() {
    if (!window.SignaturePad) {
      try {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar SignaturePad'));
          document.head.appendChild(script);
        });
      } catch (e) { toast.error('Error al cargar librería de firmas'); return; }
    }

    setTimeout(() => {
      ['tecnico_servicio', 'usuario', 'responsable_linea', 'responsable_posventa'].forEach(tipo => {
        const canvas = document.getElementById(`firma-${tipo}`);
        if (!canvas || this[`signaturePad_${tipo}`]) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        const pad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)',
          penColor: 'rgb(0, 0, 0)'
        });
        this[`signaturePad_${tipo}`] = pad;

        const placeholder = document.getElementById(`firma-placeholder-${tipo}`);
        if (placeholder) {
          canvas.addEventListener('pointerdown', () => placeholder.style.display = 'none');
        }

        // Activar "Hay cambios sin guardar" al terminar un trazo
        if (this._showUnsaved) pad.addEventListener('endStroke', () => this._showUnsaved());
      });
    }, 100);
  },

  _showUnsaved() {
    this.data.hasUnsavedChanges = true;
    const banner = document.getElementById('unsavedBanner');
    if (banner) banner.style.display = 'flex';
  },

  _hideUnsaved() {
    this.data.hasUnsavedChanges = false;
    const banner = document.getElementById('unsavedBanner');
    if (banner) banner.style.display = 'none';
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  limpiarFirma(tipo) {
    const pad = this[`signaturePad_${tipo}`];
    if (pad) {
      pad.clear();
      const placeholder = document.getElementById(`firma-placeholder-${tipo}`);
      if (placeholder) placeholder.style.display = 'block';
    }
  },

  cambiarFirmaExistente(tipo) {
    const r = this.data.reporte;
    if (r) r[`${tipo}_firma_url`] = null;
    this.data.hasUnsavedChanges = true;
    this.renderFormularioEdicion();
    this.showTab('firmas');
  },

  async subirFirmas() {
    const urls = {};
    const uploads = [];
    const tipos = ['tecnico_servicio', 'usuario', 'responsable_linea', 'responsable_posventa'];
    const r = this.data.reporte;
    const numSerie = r?.num_serie;

    for (const tipo of tipos) {
      // Guarda por URL: solo subir si NO existe URL persistida.
      // "Cambiar firma" pone la URL a null, así que la única vía para re-subir es ese flujo.
      const urlExistente = r?.[`${tipo}_firma_url`];
      const pad = this[`signaturePad_${tipo}`];
      if (!urlExistente && pad && !pad.isEmpty()) {
        const blob = await this.toBlob(pad);
        uploads.push(
          recepcionService.subirFirma(blob, `firma-${tipo}-rg-${Date.now()}.png`, numSerie, 'reporte_garantia')
            .then(url => { urls[`${tipo}_firma_url`] = url; })
        );
      }
    }

    if (uploads.length > 0) await Promise.all(uploads);
    return urls;
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  },

  // ======================== GUARDAR NUEVO ========================

  async guardarNuevo() {
    const numSerie = document.getElementById('rgNumSerie')?.value;
    const usuario = document.getElementById('rgUsuario')?.value?.trim();
    const fechaEntrega = document.getElementById('rgFechaEntrega')?.value;
    const fechaReporte = document.getElementById('rgFechaReporte')?.value;
    const modelo = document.getElementById('rgModelo')?.value;
    const distribuidor = document.getElementById('rgDistribuidor')?.value;
    const tecnico = document.getElementById('rgTecnico')?.value;

    // Validación campos obligatorios
    if (!numSerie) { toast.error('Busque un tractor primero'); return; }
    if (!usuario) { toast.error('Ingrese el usuario'); return; }
    if (!fechaEntrega) { toast.error('Ingrese la fecha de entrega'); return; }
    if (!fechaReporte) { toast.error('Ingrese la fecha del reporte'); return; }
    if (!modelo) { toast.error('Falta el modelo del tractor'); return; }
    if (!document.getElementById('rgHrOperacion')?.value) { toast.error('Ingrese las horas de operación'); return; }
    if (!distribuidor) { toast.error('Seleccione un distribuidor'); return; }
    if (!tecnico) { toast.error('Seleccione un técnico de servicio'); return; }

    const data = {
      num_serie: numSerie,
      modelo: modelo,
      usuario: usuario,
      fecha_entrega: fechaEntrega,
      fecha_reporte: fechaReporte,
      hr_operacion: parseInt(document.getElementById('rgHrOperacion')?.value) || null,
      distribuidor: distribuidor,
      tecnico_servicio: tecnico,
      descripcion_problema: document.getElementById('rgDescripcion')?.value?.toUpperCase() || null,
      labor_previa_mantenimiento: document.getElementById('rgLaborPrevia')?.value?.toUpperCase() || null,
      causas_problema: document.getElementById('rgCausas')?.value?.toUpperCase() || null,
      observaciones_diagnostico: document.getElementById('rgObservaciones')?.value?.toUpperCase() || null,
      dictamen: document.getElementById('rgDictamen')?.value || null,
      fecha_cierre: document.getElementById('rgFechaCierre')?.value || null,
      cap: document.getElementById('rgCap')?.checked || false,
      ref: document.getElementById('rgRef')?.checked || false,
      fac: document.getElementById('rgFac')?.checked || false,
      aye: document.getElementById('rgAye')?.checked || false,
      responsable_linea: document.getElementById('rgRespLinea')?.value || null,
      responsable_posventa: document.getElementById('rgRespPosventa')?.value || null
    };

    try {
      // Subir fotos si hay
      if (this.data.fotos.length > 0) {
        this._showProgress('Subiendo fotos...');
        const fotoUrls = await recepcionService.subirMultiplesFotos(
          this.data.fotos,
          numSerie,
          undefined,
          'reporte_garantia'
        );
        data.fotos = fotoUrls;
      }

      // Subir firmas si hay
      this._showProgress('Subiendo firmas...');
      const firmaUrls = await this.subirFirmas();
      Object.assign(data, firmaUrls);

      this._showProgress('Creando reporte...');
      const response = await posventaService.crearReporteGarantia(data);
      this._hideProgress();
      this.data.hasUnsavedChanges = false;
      toast.success('Reporte de garantía creado exitosamente');
      const reporte = response.data || response;
      router.navigate(`/posventa/reportes-garantia/${reporte.id}`);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al crear reporte');
    }
  },

  // ======================== GUARDAR CAMBIOS (EDICIÓN) ========================

  async guardarCambios() {
    const r = this.data.reporte;

    const data = {
      fecha_entrega: document.getElementById('rgFechaEntrega')?.value,
      fecha_reporte: document.getElementById('rgFechaReporte')?.value,
      hr_operacion: parseInt(document.getElementById('rgHrOperacion')?.value) || null,
      descripcion_problema: document.getElementById('rgDescripcion')?.value?.toUpperCase() || null,
      labor_previa_mantenimiento: document.getElementById('rgLaborPrevia')?.value?.toUpperCase() || null,
      causas_problema: document.getElementById('rgCausas')?.value?.toUpperCase() || null,
      observaciones_diagnostico: document.getElementById('rgObservaciones')?.value?.toUpperCase() || null,
      dictamen: document.getElementById('rgDictamen')?.value || null,
      fecha_cierre: document.getElementById('rgFechaCierre')?.value || null,
      cap: document.getElementById('rgCap')?.checked || false,
      ref: document.getElementById('rgRef')?.checked || false,
      fac: document.getElementById('rgFac')?.checked || false,
      aye: document.getElementById('rgAye')?.checked || false,
      responsable_linea: document.getElementById('rgRespLinea')?.value || null,
      responsable_posventa: document.getElementById('rgRespPosventa')?.value || null
    };

    try {
      // Subir fotos nuevas
      if (this.data.fotos.length > 0) {
        this._showProgress('Subiendo fotos...');
        const fotoUrls = await recepcionService.subirMultiplesFotos(
          this.data.fotos,
          r.num_serie,
          undefined,
          'reporte_garantia'
        );
        data.fotos = [...this.data.fotosExistentes.map(f => f.foto_url), ...fotoUrls];
      }

      // Subir firmas nuevas
      this._showProgress('Subiendo firmas...');
      const firmaUrls = await this.subirFirmas();
      Object.assign(data, firmaUrls);

      this._showProgress('Guardando cambios...');
      await posventaService.actualizarReporteGarantia(r.id, data);
      this._hideProgress();
      this.data.hasUnsavedChanges = false;
      toast.success('Cambios guardados exitosamente');
      await this.cargarReporte(r.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al guardar cambios');
    }
  },

  // ======================== COMPLETAR REPORTE ========================

  async completarReporte() {
    // Si hay cambios pendientes, exigir guardar primero
    if (this.data.hasUnsavedChanges) {
      toast.warning('Guarde los cambios antes de completar el reporte');
      return;
    }

    const r = this.data.reporte;

    // Validación por tab
    const descripcion = document.getElementById('rgDescripcion')?.value?.trim();
    const laborPrevia = document.getElementById('rgLaborPrevia')?.value?.trim();
    if (!descripcion || !laborPrevia) {
      toast.error('Faltan campos en Problema');
      this.showTab('problema');
      return;
    }

    const totalFotos = this.data.fotosExistentes.length + this.data.fotos.length;
    if (totalFotos < 1) {
      toast.error('Falta evidencia fotográfica');
      this.showTab('evidencia');
      return;
    }

    const causas = document.getElementById('rgCausas')?.value?.trim();
    const observaciones = document.getElementById('rgObservaciones')?.value?.trim();
    const dictamen = document.getElementById('rgDictamen')?.value;
    const fechaCierre = document.getElementById('rgFechaCierre')?.value;
    const respLinea = document.getElementById('rgRespLinea')?.value;
    const respPosventa = document.getElementById('rgRespPosventa')?.value;
    if (!causas || !observaciones || !dictamen || !fechaCierre || !respLinea || !respPosventa) {
      toast.error('Faltan campos en Diagnóstico');
      this.showTab('diagnostico');
      return;
    }

    // Validar firmas persistidas
    for (const tipo of ['tecnico_servicio', 'usuario', 'responsable_linea', 'responsable_posventa']) {
      if (!r[`${tipo}_firma_url`]) {
        toast.error('Faltan firmas');
        this.showTab('firmas');
        return;
      }
    }

    if (!confirm('¿Completar el reporte? Esta acción no se puede deshacer.')) return;

    try {
      this._showProgress('Completando reporte...');
      await posventaService.completarReporteGarantia(r.id);
      this._hideProgress();
      this.data.hasUnsavedChanges = false;
      toast.success('Reporte completado exitosamente');
      await this.cargarReporte(r.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al completar reporte');
    }
  },

  // ======================== IMPRIMIR / PDF ========================

  imprimir() {
    if (!this.data.reporte) return;
    router.navigate(`/posventa/reportes-garantia/${this.data.reporte.id}/print`);
  },

  async descargarPDF() {
    const r = this.data.reporte;
    if (!r) return;

    toast.info('Generando PDF...');

    try {
      if (typeof html2pdf === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar librería PDF'));
          document.head.appendChild(script);
        });
      }

      const { default: PrintReporteGarantia } = await import('./PrintReporteGarantia.js');

      // Renderizar en #content para que sea visible para html2canvas
      const contentEl = document.getElementById('content');
      const savedHTML = contentEl.innerHTML;
      const html = PrintReporteGarantia.generateHTML(r);
      contentEl.innerHTML = html;

      // Clonar las páginas .pg en un tempDiv aislado
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.id = 'tempPrintContent';
      document.body.appendChild(tempDiv);

      // Clonar todo el contenido renderizado (style + páginas)
      const clonedContent = document.createElement('div');
      Array.from(contentEl.children).forEach(child => {
        clonedContent.appendChild(child.cloneNode(true));
      });
      tempDiv.appendChild(clonedContent);

      // Restaurar vista original inmediatamente
      contentEl.innerHTML = savedHTML;

      // Esperar a que las imágenes carguen
      const imgs = tempDiv.querySelectorAll('img');
      await Promise.all(Array.from(imgs).map(img =>
        img.complete ? Promise.resolve() : new Promise(res => { img.onload = res; img.onerror = res; })
      ));

      await new Promise(res => setTimeout(res, 300));

      const opt = {
        margin: 0,
        filename: `Reporte_Garantia_${r.num_serie || r.id}.pdf`,
        image: { type: 'png', quality: 1 },
        html2canvas: { scale: 3, useCORS: true, scrollY: 0, letterRendering: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: 'avoid-all', before: '.pg-page2' }
      };

      await html2pdf().set(opt).from(clonedContent).save();
      document.body.removeChild(tempDiv);
      toast.success('PDF descargado');
    } catch (error) {
      toast.error(error.message || 'Error al generar PDF');
    }
  },

  // ======================== UTILS ========================

  _setupUnsavedChangesListener() {
    setTimeout(() => {
      const inputs = document.querySelectorAll('#reporteContent input, #reporteContent textarea, #reporteContent select');
      inputs.forEach(input => {
        input.addEventListener('change', () => {
          this.data.hasUnsavedChanges = true;
          const banner = document.getElementById('unsavedBanner');
          if (banner) banner.style.display = 'flex';
        });
        if (input.tagName === 'TEXTAREA' || input.type === 'text') {
          input.addEventListener('input', () => {
            this.data.hasUnsavedChanges = true;
            const banner = document.getElementById('unsavedBanner');
            if (banner) banner.style.display = 'flex';
          });
        }
      });
    }, 200);

    window._rgBeforeUnload = (e) => {
      if (this.data.hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', window._rgBeforeUnload);
  },

  volverConConfirmacion() {
    if (this.data.hasUnsavedChanges) {
      if (!confirm('Hay cambios sin guardar. ¿Desea salir?')) return;
    }
    this.data.hasUnsavedChanges = false;
    if (window._rgBeforeUnload) window.removeEventListener('beforeunload', window._rgBeforeUnload);
    // Limpiar SignaturePads
    ['tecnico_servicio', 'usuario', 'responsable_linea', 'responsable_posventa'].forEach(tipo => {
      this[`signaturePad_${tipo}`] = null;
    });
    router.navigate('/posventa/reportes-garantia');
  }
};
